import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Tabs, Tab, CircularProgress, Alert } from '@mui/material';
import { useTenant } from '@lingaai/shared-hooks';
import { OverviewTab } from './tenant-details/OverviewTab';
import { FundsTab } from './tenant-details/FundsTab';
import { UsersTab } from './tenant-details/UsersTab';
import { DemoControlsTab } from './tenant-details/DemoControlsTab';

export function TenantDetails() {
  const { tenantId } = useParams<{ tenantId: string }>();
  const [activeTab, setActiveTab] = useState(0);
  const { data: tenant, isLoading, error } = useTenant(tenantId!);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || !tenant) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error instanceof Error ? error.message : 'Tenant not found'}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        {tenant.name}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
          <Tab label="Overview" />
          <Tab label="Funds" />
          <Tab label="All Users" />
          <Tab label="Demo Controls" />
        </Tabs>
      </Box>

      {activeTab === 0 && <OverviewTab tenant={tenant} />}
      {activeTab === 1 && <FundsTab tenantId={tenant.id} />}
      {activeTab === 2 && <UsersTab tenantId={tenant.id} />}
      {activeTab === 3 && <DemoControlsTab tenantId={tenant.id} />}
    </Box>
  );
}
